var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var emotion_1 = require("emotion");
var react_1 = __importStar(require("react"));
var use_did_mount_1 = __importDefault(require("@rooks/use-did-mount"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var dropdown_1 = __importDefault(require("./dropdown"));
var styles_1 = __importDefault(require("./styles/"));
var icon_1 = __importDefault(require("./svg/icon"));
var AppSwitcher = function (_a) {
    var apps = _a.apps, activeApplicationKey = _a.activeApplicationKey, onActivate = _a.onActivate;
    use_did_mount_1.default(function () {
        js_cookie_1.default.set('active-application', activeApplicationKey, { domain: '.cinesend.com' });
    });
    var buttonRef = react_1.useRef(null);
    var _b = react_1.useState(false), isDropdownVisible = _b[0], toggleDropdownVisbility = _b[1];
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("button", { ref: buttonRef, onClick: function () { return toggleDropdownVisbility(true); }, className: 'cs-button ' + emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\t\t\t", ";\n\t\t\t\t"], ["\n\t\t\t\t\t", ";\n\t\t\t\t"])), styles_1.default.button) },
            react_1.default.createElement(icon_1.default, null)),
        buttonRef &&
            buttonRef.current && (react_1.default.createElement(dropdown_1.default, { open: isDropdownVisible, onClose: function () { return toggleDropdownVisbility(false); }, apps: apps, activeApplicationKey: activeApplicationKey, buttonRef: buttonRef.current }))));
};
exports.default = AppSwitcher;
var templateObject_1;
//# sourceMappingURL=index.js.map